import { useAccountStore } from "@/stores/Account";
import { useUserSettingsStore } from "@/stores/UserSettings";
import { useFavoriteChannelsStore } from "@/stores/FavoriteChannels";
import { useApplicationStore } from "@/stores/Application";
import { SilentLogin, type SilentLoginParams } from "@ca.vmedia.tv/domains"

const { $domains } = useNuxtApp();

export const useReLogin = () => {
    const {
        SilentLoginOkta,
        Login,
    } = useAccountStore();
    const {
        fetchSettings,
    } = useUserSettingsStore();
    const {
        fetchFavChannelsIds,
    } = useFavoriteChannelsStore();
    const {
        setDisableSentry,
    } = useApplicationStore();

    const reLogin = async (): Promise<void> => {
        const params: SilentLoginParams = {
            domains: $domains,
            SilentLoginOkta,
            fetchSettings,
            fetchFavChannelsIds, //TODO: Maybe we can remove this. We use it in other places
            Login,
            setDisableSentry
        };
        await SilentLogin(params);
    }

    return {
        reLogin
    };
};